// 客户管理
import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/inventory',
    name: 'Inventory',
    component: defaultLayout,
    meta: withAccessKeyMeta('inventory', {
      locale: 'common.menus.inventory',
      requiresAuth: true,
      icon: 'order-status-delivered2',
      hideChildrenInMenu: true,
      activeMenu: 'Inventory',
      order: 4,
    }),
    children: [
      {
        path: '',
        name: 'IndexInventory',
        component: () => import('@/views/inventory/index.vue'),
        meta: {
          locale: 'common.menus.inventory',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Inventory',
          isTopMenu: true,
        },
      },
      {
        path: 'detail',
        name: 'DetailInventory',
        // component: () => import('@/views/inventory/detail.vue'),
        component: () => import('@/views/inventory/inventory-detail.vue'),
        meta: {
          locale: 'common.inventoryDetail',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Inventory',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
// export default []
